module.exports = require("./../../_gen/starling/display/Sprite3D");